// extracted by mini-css-extract-plugin
export default {"section":"rdYqw","activities":"nZr1n","empty-state":"n6kw8","emptyState":"n6kw8"};